<template>
  <div>
    <img class="img-box" v-for="(img, index) in imgList" v-lazy="img" :key="index" />
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgList: [
        'https://oss.aqdpay.com/appweb/activeimg/eduimg/1.png',
        'https://oss.aqdpay.com/appweb/activeimg/eduimg/2.png',
        'https://oss.aqdpay.com/appweb/activeimg/eduimg/3.png',
        'https://oss.aqdpay.com/appweb/activeimg/eduimg/4.png',
        'https://oss.aqdpay.com/appweb/activeimg/eduimg/5.png'
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  display: block;
  width: 100%;
}
</style>
